module.exports = __webpack_public_path__ + "static/media/atomic-white.c82643d0.png";